import { Component, OnInit, Input, ɵConsole } from '@angular/core';
import { SetService, PageService, FormControlService, HttpService, JwtService } from 'ngx-block-core';
import { FormGroup, FormControl, Validators, ValidatorFn } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd';
import { selectSize2 } from "../../../data/data";
import { forEach } from '@angular/router/src/utils/collection';
import { NzMessageService } from 'ng-zorro-antd';

@Component({
  selector: 'app-sucu01-data0030001',
  templateUrl: './sucu01-data0030001.component.html',
  styleUrls: ['./sucu01-data0030001.component.css']
})
export class Sucu01Data0030001Component implements OnInit {
  dataSet: { id: number, edit: boolean, checked: boolean, disabled: boolean, data?: any, first?: boolean }[] = [];
  forms: { [key: string]: FormGroup } = {};
  nzLoading = {};
  editNumber = 0;
  visible = false;
  submitSpinning = false;
  submitData = {
    PARTNO: '',
    reason: '',
    index: 0
  }

  @Input() local = false;
  @Input() static = false;
  @Input() blockid = "-1";
  @Input() layoutid = "-1";

  @Input() sets = {
    blockCode: "sucublock51",
    blockId: "",
    blockName: "存储列表",
    layoutId: "",
    blockType: "table",
    blockChildType: '',
    versionCode: 26,
    attributes: [],
    events: [
      {
        label: "更新条数",
        value: "updateNum",
        data: {
          setParams: ["tablefields"]
        }
      },
      {
        label: "重置",
        value: "reset",
        data: { setParams: ["微重置 : true|false，不清空表单，只清空表单的可编辑项"] }
      },
      {
        label: "搜索刷新",
        value: "search",
        data: {
          setParams: ["tablefields", 'searchType', '附加设置']
        }
      },
      {
        label: "自动焦点",
        value: "focus",
        data: { setParams: ["延时 : 100 1000"] }
      },

    ],
    styles: {
      "nzPageSizeOptions": [10, 20, 40, 60, 100],
      nzShowSizeChanger: false,
      "nzPageSize": 8,
      "nzShowPagination": true,
      "nzShowQuickJumper": true,
      "nzHeadHeight": 50,
      "nzlineHeight": 1,
      "nzTitle": "",
      "nzSize": "small",
      'nzMore': false,
      "nzScroll": false,
      "nzScrollValueY": 400,
      "nzScrollcolumn": false,
      "nzScrollValueX": 1500,
      nzHiddenButton: false,
      nzHiddenTools: false,
      nzClearAfterInsert: false,
      nzNum: 0,
      nzDynamicNum: false,
      nzNumSql: "",
      nzOnlyInsert: false
    },
    datas: {
      nzEnterFilter: false,
      nzNeedOrganize: false,
      jichengLeft: false,
      jichengRight: false,
      jichengRightId: '',
      jichengLeftId: '',
      nzSearch: {
        nzUsed: false,
        searchColumn: [
          // {
          //   field:"",
          //   name:"=",//搜索方式
          //   type:"",
          //   instruction:"",
          //   valueType:"static",
          //   valueKey:"",//场景值KEY
          //   value1:"",
          //   value2:""
          // }
        ],
        sortColumn: [
          // {
          //   field:"",
          //   type:""
          // }
        ]
      },
      nzTableName: "",
      sysFields: {
        isDelete: "",
        primaryKeys: [],
        createUser: ""
      },
      virtualColumn: [],
      searchColumn: [],
      showColumn: [],
      allColumn: [],
      ColumnData: {},
      nzSearchMap: [],
      nzForm: {
        nzFormType: "",
        nzDefaultSet: {
          primaryKey: [{
            name: "",
            type: "int",
            value: "",
            rule: "commonsequence",
            procudure: "",
          }],
          systemData: [],
          deleteFlag: [],
          otherData: []
        }
      },
      nzServiceParam: [],
      nzServiceParamDetail: { "sequ": 1 },
      nzHiddendatas: {
        nzNames: [],
        nzSets: {
          "id": 1
        }
      },
    }
  };
  setData = []
  setDataInit() {
    this.setData = [
      {
        tabName: '数据',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzStoreTable' },
              {
                name: 'nzHiddendatas', inputs: {
                  columnList: this.sets.datas.searchColumn
                }
              }
            ]
          }
        ]
      },
      {
        tabName: '样式',
        datas: [
          {
            type: 'styles',
            data: [
              {
                name: 'input',
                inputs: { nzText: "积木名称 : ", nzKeys: ['blockName'] }
              },
              {
                name: 'switch',
                inputs: {
                  nzText: "分页 : ", nzKeys: ['styles', 'nzShowPagination']
                }
              },
              {
                name: 'nzPageSizeOptions',
              },
              {
                name: 'number',
                inputs: {
                  nzText: "初始页条数 : ", nzKeys: ['styles', 'nzPageSize'],
                }
              },

              {
                name: 'switch',
                inputs: {
                  nzText: "分页组选择 : ", nzKeys: ['styles', 'nzShowSizeChanger']
                }
              },

              {
                name: 'switch',
                inputs: {
                  nzText: "分页跳转 : ", nzKeys: ['styles', 'nzShowQuickJumper']
                }
              },
              {
                name: 'input',
                inputs: {
                  nzText: "表头名称 : ", nzKeys: ['styles', 'nzTitle']
                }
              },
              {
                name: 'number',
                inputs: {
                  nzText: "行间距 : ", nzKeys: ['styles', 'nzlineHeight'], nzStyle: [0, 3, 0.1]
                }
              },
              {
                name: 'radio',
                inputs: { nzText: "大小 : ", nzKeys: ['styles', 'nzSize'], nzData: selectSize2 }
              },
              {
                name: 'switch',
                inputs: {
                  nzText: "单条模式 : ", nzKeys: ['styles', 'nzMore']
                }
              },
              {
                name: 'switch',
                inputs: {
                  nzText: "禁止提交 : ", nzKeys: ['styles', 'nzHiddenButton']
                }
              },
              {
                name: 'switch',
                inputs: {
                  nzText: "禁用工具栏 : ", nzKeys: ['styles', 'nzHiddenTools']
                }
              },

              {
                name: 'switch',
                inputs: {
                  nzText: "清除表格 : ", nzKeys: ['styles', 'nzClearAfterInsert'], nzPopContent: "新增后清除表格"
                }
              },
              {
                name: 'switch',
                inputs: {
                  nzText: "只新增 : ", nzKeys: ['styles', 'nzOnlyInsert'],
                }
              },
              {
                name: 'number',
                inputs: {
                  nzText: "固定条数 : ", nzKeys: ['styles', 'nzNum'], nzStyle: [0, 20, 1]
                }
              },
              {
                name: 'switch',
                inputs: {
                  nzText: "动态条数 : ", nzKeys: ['styles', 'nzDynamicNum'], nzPopContent: "开启后一上来不加载"
                }
              },

              {
                name: 'input',
                inputs: {
                  nzText: "固定条数sql : ", nzKeys: ['styles', 'nzNumSql'], nzType: "textarea",
                  nzAutosize: { minRows: 3, maxRows: 6 },
                  nzPopContent: "@linkage1"
                }
              },
              {
                name: 'switch',
                inputs: {
                  nzText: "集成左 : ", nzKeys: ['datas', 'jichengLeft']
                }
              },
              {
                name: 'switch',
                inputs: {
                  nzText: "集成右 : ", nzKeys: ['datas', 'jichengRight']
                }
              },
              {
                name: 'select',
                inputs: { nzText: "集成右绑定 : ", nzKeys: ['datas', 'jichengRightId'], nzData: this.setService.getBlock('table', "*") },
              },
              {
                name: 'select',
                inputs: { nzText: "集成左绑定 : ", nzKeys: ['datas', 'jichengLeftId'], nzData: this.setService.getBlock('table', "*") },
              },
              {
                name: 'nzScroll',
                inputs: {
                  needY: false
                }

              },
              {
                name: 'switch',
                inputs: { nzText: "回车过滤 : ", nzKeys: ['datas', 'nzEnterFilter'] }
              },


            ]
          },


        ]
      },
      {
        tabName: '查询功能',
        datas: [
          {
            type: 'datas',
            data: [

              { name: 'nzSearchMap' },
            ]
          },
        ]
      },
    ]
  }
  constructor(
    public setService: SetService,
    private formControlService: FormControlService,
    private http: HttpService,
    private activatedRoute: ActivatedRoute,
    private modalService: NzModalService,
    private pageService: PageService,
    private jwtService: JwtService,
    private message: NzMessageService
  ) { }
  otherSets = {
    /** 必须在编辑界面 */
    editMast: false,
    notDelete: false,
    removeFormToReset: false,
    notReset: '',
    isFirst: false,
    disabled: false,
    width: 60
  }
  ngOnInit() {

    this.baseInit();
    this.Listening();
    if (this.sets.datas.nzSearch.nzUsed) {
      this.pzSearchData()
    }
    this.autoUpdate()
    if (this.sets.datas.jichengLeft) {
      this.otherSets.editMast = true;
      this.otherSets.notDelete = true;
      this.otherSets.removeFormToReset = true;
      this.otherSets.notReset = 'PARTNO';
      this.otherSets.disabled = true;
      this.otherSets.width = 20;


    }
    if (this.sets.datas.jichengRight) {
      this.otherSets.editMast = true;
      this.otherSets.notDelete = true;
      this.otherSets.notReset = 'PARTNO';
      this.otherSets.disabled = true;

    }
  }
  autoUpdate() {

    //v2
    if (this.sets.versionCode < 2) {

      for (const key in this.sets.datas.ColumnData) {
        //编辑查重
        if (typeof this.sets.datas.ColumnData[key]['nzFormGroupData']['nzValue']['nzFirstValue'] == "undefined") {
          this.sets.datas.ColumnData[key]['nzFormGroupData']['nzValue']['nzFirstValue'] = ""
        }
        //联动datas.nzLinkage =="undefined"
        if (typeof this.sets.datas.ColumnData[key]['nzBlockSets']['datas']['nzLinkage'] == "undefined") {
          this.sets.datas.ColumnData[key]['nzBlockSets']['datas']['nzLinkage'] = {
            nzUsed: true,
            nzEvents: [

            ],
          };
          this.sets.datas.ColumnData[key]['nzBlockSets']['datas']['nzLinkageData'] = {
            nzDynamicSql: ""
          };
        }
      }


      this.sets.versionCode = 2;
    }
    //v3
    if (this.sets.versionCode < 3) {

      if (typeof this.sets.styles.nzMore == "undefined") {
        this.sets.styles.nzMore = true;
      }
      this.sets.versionCode = 3;
    }

    if (this.sets.versionCode < 4) {

      this.sets.blockCode = "sucublock51";

      this.sets.versionCode = 4;
    }
    //vc:5
    //参数值
    if (this.sets.versionCode < 5) {
      if (typeof this.sets.datas['nzServiceParam'] == "undefined") {
        this.sets.datas['nzServiceParam'] = [];
        this.sets.datas['nzServiceParamDetail'] = { "sequ": 1 }
      }
      this.sets.versionCode = 5;
    }
    //v6
    if (this.sets.versionCode < 6) {

      for (const key in this.sets.datas.ColumnData) {
        //编辑查重
        if (typeof this.sets.datas.ColumnData[key]['nzFormGroupData']['sets'] == "undefined") {
          this.sets.datas.ColumnData[key]['nzFormGroupData']['sets'] = {
            formId: this.blockid
          }
        }
      }
      this.sets.versionCode = 6;
    }
    //v7 冻结列
    if (this.sets.versionCode < 7) {
      this.sets.styles['nzScroll'] = false;
      this.sets.styles['nzScrollValueY'] = 400;
      this.sets.styles['nzScrollcolumn'] = false;
      this.sets.styles['nzScrollValueX'] = 1500;

      for (const key in this.sets.datas.ColumnData) {
        //编辑查重
        if (typeof this.sets.datas.ColumnData[key]['nzScroll'] == "undefined") {
          this.sets.datas.ColumnData[key]['nzLeft'] = null;
          this.sets.datas.ColumnData[key]['nzRight'] = null;
          this.sets.datas.ColumnData[key]['nzScroll'] = false;
          this.sets.datas.ColumnData[key]['autowidth'] = false;

        }

      }
      this.sets.versionCode = 7;
    }
    //v8 冻结列
    if (this.sets.versionCode < 8) {
      this.sets.styles['nzHiddenButton'] = false;
      this.sets.versionCode = 8;
    }
    //v9 清除
    if (this.sets.versionCode < 9) {
      this.sets.styles['nzClearAfterInsert'] = false;
      this.sets.versionCode = 9;
    }

    //v10
    if (this.sets.versionCode < 10) {

      for (const key in this.sets.datas.ColumnData) {
        //编辑查重
        if (typeof this.sets.datas.ColumnData[key]['onlyValue'] == "undefined") {
          this.sets.datas.ColumnData[key]['onlyValue'] = false;
        }
      }
      this.sets.versionCode = 10;
    }
    //11
    if (this.sets.versionCode < 11) {


      this.sets.styles['nzNum'] = 0;
      this.sets.styles['nzNumSql'] = "";



      this.sets.versionCode = 11;
    }


    if (this.sets.versionCode < 13) {

      for (const key in this.sets.datas.ColumnData) {
        //联动datas.nzLinkage =="undefined"
        if (typeof this.sets.datas.ColumnData[key]['nzBlockSets']['styles']['nzFocus'] == "undefined") {
          this.sets.datas.ColumnData[key]['nzBlockSets']['styles']['nzFocus'] = false;
        }
      }


      this.sets.versionCode = 13;
    }
    if (this.sets.versionCode < 14) {

      for (const key in this.sets.datas.ColumnData) {
        //联动datas.nzLinkage =="undefined"
        if (typeof this.sets.datas.ColumnData[key]['translations'] == "undefined") {
          this.sets.datas.ColumnData[key]['translations'] = [];
        }
      }


      this.sets.versionCode = 14;
    }

    if (this.sets.versionCode < 16) {

      this.sets.styles['nzOnlyInsert'] = false;
      this.sets.versionCode = 16;
    }

    if (this.sets.versionCode < 17) {

      for (const key in this.sets.datas.ColumnData) {

        //联动datas.nzLinkage =="undefined"
        if (typeof this.sets.datas.ColumnData[key]['nzBlockSets']['datas']['nzHiddendatas'] == "undefined") {
          this.sets.datas.ColumnData[key]['nzBlockSets']['datas']['nzHiddendatas'] = {
            nzNames: [],
            nzSets: {
              "id": 1
            }
          }

        }
      }
      this.sets.versionCode = 17;
    }
    if (this.sets.versionCode < 18) {

      for (const key in this.sets.datas.ColumnData) {
        //编辑查重
        if (this.sets.datas.ColumnData[key]['nzFormGroupData']['sets']['formId'] === "") {
          this.sets.datas.ColumnData[key]['nzFormGroupData']['sets']['formId'] = this.blockid;
        }
      }
      this.sets.versionCode = 18;
    }
    if (this.sets.versionCode < 19) {

      this.sets.styles['nzDynamicNum'] = false;
      this.sets.versionCode = 19;
    }

    if (this.sets.versionCode < 20) {

      this.sets.datas['nzHiddendatas'] = {
        nzNames: [],
        nzSets: {
          "id": 1
        }
      }
      this.sets.versionCode = 20;
    }

    if (this.sets.versionCode < 21) {
      this.sets.styles['nzHiddenTools'] = false;
      this.sets.versionCode = 21;

    }

    if (this.sets.versionCode < 24) {
      this.sets['events'] = [
        {
          label: "更新条数",
          value: "updateNum",
          data: {
            setParams: ["tablefields"]
          }
        },
        {
          label: "重置",
          value: "reset",
          data: { setParams: ["微重置 : true|false，不清空表单，只清空表单的可编辑项"] }
        },
        {
          label: "搜索刷新",
          value: "search",
          data: {
            setParams: ["tablefields", 'searchType', '附加设置']
          }
        },
        {
          label: "自动焦点",
          value: "focus",
          data: { setParams: ["延时 : 100 1000"] }
        },


      ]
      this.sets.versionCode = 24;

    }
    if (this.sets.versionCode < 25) {
      this.sets.datas.jichengLeft = false;
      this.sets.datas.jichengRight = false;
      this.sets.versionCode = 25;

    }
    if (this.sets.versionCode < 26) {
      this.sets.datas.jichengRightId = '';
      this.sets.versionCode = 26;

    }
    if (this.sets.versionCode < 27) {
      this.sets.datas.jichengLeftId = '';
      this.sets.versionCode = 27;

    }









  }
  endId = 0
  form_addForm() {
    const disabled = this.otherSets.disabled;
    console.log('form_addForm', this.sets.styles.nzNum)
    if (this.sets.styles.nzNum !== 0) {
      if (this.dataSet.length > this.sets.styles.nzNum) {
        this.dataSet = [];
        this.forms = {};
      } else if (this.dataSet.length == this.sets.styles.nzNum) {
        this.modalService.info({
          nzTitle: "提示",
          nzContent: "不能再新增更多"
        });
        return;
      }
    } else {
      if (this.backnum.used) {
        this.dataSet = [];
        this.forms = {};
        return;
      }

    }

    if (this.dataSet.length == 0)
      this.endId = 0;

    const form = this.getFormGroup(disabled);
    if (this.sets.datas.jichengLeft) {
      form.enable();
    }
    this.forms['form' + (++this.endId)] = form;
    // this.dataSet.push(endId+1);
    console.log("item", { id: this.endId, edit: true, checked: false, disabled: false })
    if (this.sets.datas.jichengLeft || this.sets.datas.jichengRight) {
      this.dataSet.splice(0, 0, { id: this.endId, edit: true, checked: false, disabled: false, data: {} })
    } else {
      this.dataSet.splice(0, 0, { id: this.endId, edit: true, checked: false, disabled: false })
    }
    this.dataSet = [...this.dataSet]
    this.nzLoading[this.endId] = false;
    console.log("form", this.forms)
    this.editNumber = this.editNumber + 1;
    if (this.dataSet.length < this.sets.styles.nzNum) this.form_addForm();
  }
  //   http://172.16.8.114:8080/cloudblock_lhoracle/csysoperatelog
  // {
  //   "csysOperatelogName": "更换物料",
  //   "csysOperatelogResource": "did",
  //   "csysOperatelogResourceId": "物料代码",
  //   "csysOperatelogOperator": "新增",
  //   "csysOperatelogDesc":"描述"

  // }
  submitChange() {
    if (this.submitData.reason === '') {
      this.message.create('error', '原因不可为空');
      return;
    }
    this.submitSpinning = true;
    // this.http.postHttp('/csysoperatelog', {
    //   "csysOperatelogName": "更换物料",
    //   "csysOperatelogResource": "did",
    //   "csysOperatelogResourceId": this.submitData.PARTNO,
    //   "csysOperatelogOperator": "新增",
    //   "csysOperatelogDesc": this.submitData.reason

    // }).subscribe(data => {
    //   const form = this.forms['form' + this.dataSet[this.submitData.index].id] as FormGroup;
    //   form.enable();
    //   this.submitSpinning = false;
    //   this.visible = false;
    // },
    //   error => {
    //     const form = this.forms['form' + this.dataSet[this.submitData.index].id] as FormGroup;
    //     form.enable();
    //     this.submitSpinning = false;
    //     this.visible = false;
    //   })
    setTimeout(() => {
      // this.sets.datas['nzServiceParam'].forEach(param => {
      //   const paramData = this.sets.datas.nzServiceParamDetail[param];
      //   if (paramData.urlName === 'woCode') {
      //     body.woCode = this.pageService.getServiceParam(paramData, this.activatedRoute);
      //   } else if (paramData.urlName === 'potBomCode') {
      //     body.potBomCode = this.pageService.getServiceParam(paramData, this.activatedRoute);
      //   }
      // });
      const form = this.forms['form' + this.dataSet[this.submitData.index].id] as FormGroup;
      form.enable();
      this.submitSpinning = false;
      this.visible = false;
    }, 1000);
  }
  form_removeForm(index) {
    console.log('form_removeForm');
    if (this.otherSets.editMast) {
      if (this.otherSets.removeFormToReset) {

        const form = this.forms['form' + this.dataSet[index].id] as FormGroup;
        this.submitData.PARTNO = form.controls['PARTNO'].value;
        this.submitData.reason = '';
        this.submitData.index = index;
        this.visible = true;
        // form.enable();
      }
      return;
    }
    if (this.isEmpty(this.dataSet[index].data)) {
      console.log(this.forms);
      const id = this.dataSet[index].id;
      this.dataSet.splice(index, 1)
      this.dataSet = [...this.dataSet]
      delete this.forms['form' + id];
      console.log(this.forms);
    } else {
      this.dataSet[index].edit = false;
      this.dataSet = [...this.dataSet]
    }
    this.editNumber = this.editNumber - 1;
    if (this.dataSet.length < this.sets.styles.nzNum) this.form_addForm();
  }
  form_edit_one(index, data) {
    setTimeout(() => {
      this.sets.datas.showColumn.forEach(element => {
        if (this.sets.datas.ColumnData[element]['canEdit']) {
          this.forms['form' + data.id].get(element).patchValue(this.dataSet[index].data[element]);
          this.forms['form' + data.id].get(element).markAsDirty();
          this.forms['form' + data.id].get(element).updateValueAndValidity();
          console.log('form_edit_one', element, this.dataSet[index].data[element], this.forms['form' + data.id].get(element).value)

        }
      });
    }, 3);



    data.edit = true;
    this.editNumber = this.editNumber + 1;


  }
  form_submit_one(index, id, otherData?) {
    this.nzLoading[id] = true;
    let url = "/system/tableSaveData";

    if (!this.isEmpty(this.dataSet[index].data) && !this.sets.styles.nzOnlyInsert) {
      console.log('this.dataSet[index].data', this.dataSet[index].data)
      url = "/system/tableUpdateData";
    }
    this.submit_InsertTableData(id, this.nzLoading, this.dataSet[index], this.sets, this.forms['form' + id], this.activatedRoute, url, this.static ? "real" : "drag", otherData);
  }
  isEmpty(data: { [key: string]: any }): boolean {
    if (!data) return true;
    let one = false;
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        one = true;
        break;
      }
    }
    return !one;
  }

  deleteflags = {};
  form_delete_more() {
    this.deleteflags = {};
    this.modalService.confirm({
      nzTitle: '确定',
      nzContent: '确认删除吗',
      nzOnOk: () => {
        for (let index = 0; index < this.dataSet.length; index++) {
          const element = this.dataSet[index];
          if (element.checked) {

            if (this.isEmpty(element.data)) {
              this.deleteflags[index] = {
                ok: true,
                id: element.id
              }
              // console.log(this.forms);
              // const id = element.id;
              // this.dataSet.splice(index, 1)
              // this.dataSet = [...this.dataSet]
              // delete this.forms['form' + id];
              // console.log(this.forms);
              // this.editNumber=this.editNumber-1;
              // this.form_delete_one_base(index)

            } else {
              this.deleteflags[index] = {
                ok: false,
                id: element.id
              }
              this.form_delete_one_base(index)
            }



          }
        }




      }
    });

  }
  form_delete_one_base(index) {
    console.log("form_delete_one_base", index)
    let id = this.dataSet[index].id
    this.nzLoading[id] = true;
    let primaryMap = [];
    let bodys = []
    this.sets['datas']['sysFields']['primaryKeys'].forEach(primaryKey => {
      primaryMap.push({
        "name": primaryKey,
        "value": this.dataSet[index].data[primaryKey]
      });
    });
    bodys.push({
      "tableName": this.sets['datas']['nzTableName'],
      "deleteFlag": this.sets['datas']['sysFields']['isDelete'],
      "primaryMap": primaryMap,
      "engineMap": {}
    });
    console.log("bodys", JSON.stringify(bodys));
    this.http.postHttp("/system/logicalDeleteData", bodys).subscribe(
      (data: any) => {
        // console.log(JSON.stringify(data));
        this.deleteflags[index]['ok'] = true;
        let flag = true;
        for (const key in this.deleteflags) {
          console.log('deleteflags', index, JSON.stringify(this.deleteflags));
          if (this.deleteflags[key]['ok'] == false) flag = false;
        }
        if (flag) {
          let num = 0
          for (const key in this.deleteflags) {
            console.log('delete', key, index, parseInt(key) - num, this.dataSet);

            this.nzLoading[this.deleteflags[key].id] = false;
            if (this.dataSet[parseInt(key) - num]['edit'])
              this.editNumber = this.editNumber - 1;
            this.dataSet.splice(parseInt(key) - num++, 1)
            this.dataSet = [...this.dataSet]
            delete this.forms['form' + this.deleteflags[key].id];
          }
          if (this.sets.datas.nzSearch.nzUsed) {
            console.log("form_delete_one_base:search");
            this.searchData(this.searchMap)
          }

        }

      }
    );
  }
  form_delete_one(index) {
    this.deleteflags = {};
    this.modalService.confirm({
      nzTitle: '确定',
      nzContent: '确认删除吗',
      nzOnOk: () => {
        this.deleteflags[index] = {
          ok: false,
          id: this.dataSet[index].id
        }
        this.form_delete_one_base(index)
      }
    });

  }
  statusOfSubmitAll = 0;
  /**
   * 
   * @param otherData  
   * @param main mainFist
   */
  form_submit_all(otherData?, main = false) {
    this.check_childTable(null, true);
    console.log('开始校验')
    //开始校验
    this.statusOfSubmitAll = 0;
    let ok = true
    // for (const key in this.forms) {
    //   const form = this.forms[key];
    //   if (!form.valid) {
    //     console.log('校验未通过', key, form)
    //     ok = false;
    //   }
    // }

    if (!main) {
      for (let index = 0; index < this.dataSet.length; index++) {
        const element = this.dataSet[index];
        if (element.edit) {
          const form = this.forms['form' + element.id];
          if (!form.valid && form.enabled) {
            console.log('校验未通过2', 'form' + element.id, form)
            ok = false;
          } else {
            console.log('通过', 'form' + element.id)
          }
        } else {
          console.log('其它', 'form' + element.id)
        }
      }
      // for (const key in this.forms) {
      //   const form = this.forms[key];
      //   if (form.enabled && !form.valid) {
      //     ok = false;
      //   }
      // }
    }


    if (!ok) {
      this.modalService.error({
        nzTitle: '校验未通过',
        nzContent: '有记录校验未通过，请检查',
      });
    } else {
      console.log('开始新增')

      for (let index = 0; index < this.dataSet.length; index++) {
        const element = this.dataSet[index];
        if (element.edit) {
          this.statusOfSubmitAll++;
          this.form_submit_one(index, element.id, otherData)
        }
      }
    }
  }
  form_submit_one_valid(index, id, otherData?) {
    if (this.check_childTable(null, true, id) == false) {
      return;
    }
    this.form_submit_one(index, id, otherData)
  }
  getFormGroup(disabled?: boolean) {
    if (typeof disabled === 'undefined' || disabled === null)
      disabled = this.otherSets.disabled;

    const column = [...this.sets.datas.showColumn, ...this.sets.datas.virtualColumn]

    let group: any = {};
    column.forEach(element => {
      if (this.sets.datas.ColumnData[element]['canEdit'])
        group[element] = this.getControl(this.sets.datas.ColumnData[element]['nzFormGroupData']);
    });
    const res = new FormGroup(group)
    if (disabled) res.disable()
    return res;
  }
  getControl(data?): FormControl {
    // console.log("getControl", JSON.stringify(data))
    return this.formControlService.getControl(data, this.activatedRoute)
    // let control = new FormControl('', this.formControlService.getValidators(data['nzValidators']));
    // return control;
  }



  baseInit() {

    if (!this.local) {//非本地
      if (!this.static) {//非静态
        if (this.setService.blocksort[this.blockid]['sets'] !== "{}") {
          this.sets = this.setService.blocksort[this.blockid]['sets'];
          console.log("json", JSON.stringify(this.sets))
        } else {
          this.setService.blocksort[this.blockid]['sets'] = this.sets;
        }
        this.sets.blockId = this.blockid;
        this.sets.layoutId = this.layoutid;
        this.setDataInit();
        if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
          this.setService.setDatas[this.blockid] = this.setData;
        }

        this.pzListening()

      }
      else {//静态
        if (typeof this.sets == "string")
          this.sets = JSON.parse(<any>this.sets);
        this.blockid = this.sets.blockId;
        this.layoutid = this.sets.layoutId;

      }
    }
    this.pageService.pageBlockDatas[this.blockid] = {
      nzServiceParam: this.sets.datas.nzServiceParam,
      nzServiceParamDetail: this.sets.datas.nzServiceParamDetail,
      nzHiddendatas: {

      }
    }
  }
  async submit_InsertTableData(id, nzLoading, dataSet, sets, form, activatedRoute: ActivatedRoute, url = "/system/tableSaveData", type = "real", otherData) {
    console.log("form", form, url)
    let dataitem = {};
    if (!this.isEmpty(dataSet['data'])) {
      dataitem = dataSet['data']
    }
    const nzDataSource = sets.datas.nzTableName
    const nzDefaultSet = sets.datas.nzForm.nzDefaultSet
    const ColumnData = sets.datas.ColumnData
    //获取表信息
    let data = {};
    data[nzDataSource] = [];

    sets.datas.showColumn.forEach(column => {
      if (this.sets.datas.ColumnData[column]['canEdit'] && this.sets.datas.sysFields.primaryKeys.indexOf(column) < 0) {
        const blockdata = ColumnData[column];// nzFormGroupData 总数据
        const nzKey = blockdata['nzFormGroupData']['nzKey'];//表单key
        const type = blockdata['type']
        let value = form.get(nzKey).value
        dataitem[column] = value
        switch (type) {
          case "text":

            data[nzDataSource].push(
              {
                name: column,
                type: "string",
                rule: "",
                value: value
              }
            );
            break;
          case "select":
            data[nzDataSource].push(
              {
                name: column,
                type: "string",
                rule: "",
                value: value
              }
            );
            break;
          case "numerical":
            data[nzDataSource].push(
              {
                name: column,
                type: "string",
                rule: "",
                value: value
              }
            );
            break;

          default:
            break;
        }
      } else {
      }


    });
    console.log("nzDefaultSet", JSON.stringify(nzDefaultSet))
    for (let index = 0; index < nzDefaultSet.otherData.length; index++) {
      const element = nzDefaultSet.otherData[index];
      switch (element.type) {
        case 'static':
          data[nzDataSource].push(
            {
              name: element.field,
              type: "string",
              rule: "",
              value: element.param0
            }
          );
          break;
        case 'url':

          data[nzDataSource].push(
            {
              name: element.field,
              type: "string",
              rule: "",
              value: this.pageService.getRouteParams(activatedRoute, element.key)
            }
          );

          break;
        case 'customRule':
          console.log("customRule")
          data[nzDataSource].push(
            {
              name: element.field,
              type: "string",
              rule: "",
              value: this.formControlService.getTextByRule(element.param0)
            }
          );

          break;
        case 'paramValue':
          console.log("paramValue", sets.blockId, this.blockid)
          console.log('paramValue2', this.pageService.pageBlockDatas[this.blockid]);

          data[nzDataSource].push(
            {
              name: element.field,
              type: "string",
              rule: "",
              value: this.pageService.replaceParam("@" + element.param0 + "@", sets.blockId)
            }
          );

          break;
        case 'blockValue':
          console.log("blockValue33", element, this.pageService.pageBlockDatas[this.blockid + 'form' + id + element.key])

          for (let index = 0; index <= 10; index--) {
            if (this.pageService.pageBlockDatas[this.blockid + 'form' + id + element.key]['nzHiddendatas'][element.param0] !== undefined) {
              console.log("blockValue-ok3", JSON.stringify(element), JSON.stringify(this.pageService.pageBlockDatas[this.blockid + 'form' + id + element.key]['nzHiddendatas']))
              let nzHiddendatas = this.pageService.pageBlockDatas[this.blockid + 'form' + id + element.key]['nzHiddendatas'][element.param0];
              if (nzHiddendatas.state == 'success') {
                data[nzDataSource].push(
                  {
                    name: element.field,
                    type: 'string',
                    rule: '',
                    value: nzHiddendatas.value
                  }
                );
                index = 100;
                break;
              } else {
                this.message.create('error', `失败` + nzHiddendatas.state);
                console.log("失败", `失败` + nzHiddendatas.state)
                return;
              }
            } else {
              console.log("sleep", element, this.pageService.pageBlockDatas[this.blockid + 'form' + id + element.key]['nzHiddendatas'])
              await this.pageService.sleep(50);
            }
            console.log("forend")

          }

          break;

        default:
          break;
      }
    }



    //额外值
    console.log('otherData', typeof otherData, otherData)
    if (typeof otherData != "undefined") {
      otherData.forEach(element => {
        data[nzDataSource].push(element);
      });

    }


    //组装body
    //1.处理主键
    if (url == "/system/tableUpdateData") {
      if (nzDefaultSet['primaryKey'].length > 0)
        nzDefaultSet['primaryKey'][0].value = dataSet['data'][nzDefaultSet['primaryKey'][0].name];
    } else {
      if (nzDefaultSet['primaryKey'].length > 0)
        nzDefaultSet['primaryKey'][0].value = "";
    }
    const body = {
      tableName: nzDataSource,
      primaryKey: nzDefaultSet['primaryKey'],
      systemData: nzDefaultSet['systemData'],
      deleteFlag: nzDefaultSet['deleteFlag'],
      data: data[nzDataSource],
      "engineMap": {}
    }
    //隐藏联动值



    //调用接口
    console.log("body", JSON.stringify(body), url)

    this.http.postHttp(url, body).subscribe(
      (data: any) => {
        console.log("成功", JSON.stringify(data))
        // form.reset() 
        nzLoading[id] = false;
        if (nzDefaultSet['primaryKey'].length > 0 && url != "/system/tableUpdateData")
          dataitem[nzDefaultSet['primaryKey'][0].name] = data.data;

        if (typeof otherData != "undefined" && url != "/system/tableUpdateData") {

          otherData.forEach(element => {
            dataitem[element.name] = element.value;

          });
          this.statusOfSubmitAll--;
          if (this.statusOfSubmitAll <= 0) {
            console.log('waitMainInsert', 'ok', this.blockid)
            if (this.sets.datas.jichengRight) {
              this.setService.setPublicStatus(this.blockid, 'mainInsert', 'waitMainInsert2', 1)
            } else {
              this.setService.setPublicStatus(this.blockid, 'mainInsert', 'waitMainInsert', 1)
            }
          }
        }
        dataSet['data'] = dataitem
        dataSet.edit = false;
        if (this.sets.styles.nzClearAfterInsert && url != "/system/tableUpdateData") {
          this.dataSet = [];
        }
        else
          this.dataSet = [...this.dataSet]
        this.editNumber = this.editNumber - 1;

      },
      error => {
        this.statusOfSubmitAll--;
        if (this.statusOfSubmitAll <= 0) {
          console.log('waitMainInsert', 'error', this.blockid)
          if (this.sets.datas.jichengRight) {
            this.setService.setPublicStatus(this.blockid, 'mainInsert', 'waitMainInsert2', -1)
          } else {
            this.setService.setPublicStatus(this.blockid, 'mainInsert', 'waitMainInsert', -1)
          }
        }
      })

  }

  ngOnDestroy() {
    this.setService.deleteEvent(this.blockid);	//注销	
    if (!this.static) this.setService.deleteEvent(this.blockid, 'pz')
  }
  tableSort = []
  /**
   * 刷新表格
   */
  pzSearchData() {
    console.log('pzSearchData:search')
    let searchMap = {}
    this.searchData(searchMap);
  }
  nzPageIndexChange(event) {
    console.log('nzPageIndexChange:search', event)
    this.searchData(this.searchMap)
  }
  nzPageSizeChange() {
    console.log('nzPageSizeChange:search')
    this.searchData(this.searchMap)
  }

  nzTotal = 0;
  pageIndex = 1;
  loading = false;
  searchMap = {};
  searchData(searchMap, reset: boolean = false, status = { blockid: this.blockid, eventName: 'tableSearch', statuName: 'search' }, edit?: boolean, notClear?: boolean) {
    this.setService.setPublicStatus(status.blockid, status.eventName, status.statuName);
    this.loading = true;
    if (reset) {
      this.pageIndex = 1;
    }
    let clearFlag = {}
    //1.默认条件设置
    this.sets.datas.nzSearch.searchColumn.forEach(element => {

      let body = {
        "name": element.name,
        "type": "",
        "instruction": "",
        "value1": element.value1,
        "value2": ""
      }
      console.log("element", JSON.stringify(element))
      if (element.valueType == "dynamic") {

      } else if (element.valueType == "url") {

        body['value1'] = this.pageService.getRouteParams(this.activatedRoute, element['valueKey']);

      }

      if (typeof searchMap[element.field] == "undefined") {
        console.log("searchMap undefined", JSON.stringify(searchMap))
        searchMap[element.field] = [body]
      } else {

        if (element.level == 'high') {
          if (typeof clearFlag[element.name] == "undefined") {
            delete searchMap[element.field];
            searchMap[element.field] = [body]
          } else {
            searchMap[element.field].push(body);
          }

        } else {
          searchMap[element.field].push(body);
        }
      }
      if (typeof clearFlag[element.name] == "undefined")
        clearFlag[element.name] = true;
    });
    console.log('searchMap2', JSON.stringify(searchMap))
    //2.默认排序设置
    let oldSort = []
    this.tableSort.forEach(element => {
      oldSort.push(element.name);
    })
    let frontData = [], endData = []
    this.sets.datas.nzSearch.sortColumn.forEach(element => {
      let index = oldSort.indexOf(element.field);
      if (index < 0) {
        console.log("未存在", index, oldSort, element)
        //未有，根据优先级插入
        if (element.level == 'high') {
          frontData.push(
            {
              name: element.field,
              value: element.type
            }
          )
        } else {
          endData.push(
            {
              name: element.field,
              value: element.type
            }
          )
        }
      } else {
        console.log("已存在", index, oldSort, element)
        //已有，高优先级调整位置，低优先级不管
        if (element.level == 'high') {
          this.tableSort.splice(index, 1);
          frontData.push(
            {
              name: element.field,
              value: element.type
            }
          )
        } else {
          this.tableSort[index].value = element.type;
        }
        console.log("已存在2", index, oldSort, element)
      }
    })
    this.tableSort = [...frontData, ...this.tableSort, ...endData]
    console.log("this.tableSort:" + JSON.stringify(this.tableSort));
    let bodys = {
      "tableColumn": this.sets['datas']['searchColumn'],
      "tableName": this.sets['datas']['nzTableName'],
      "pageSize": this.sets['styles']['nzPageSize'],
      "nowPage": this.pageIndex,
      "tableSort": this.tableSort,
      "searchMap": searchMap,
      "engineMap": {}
    }
    if (this.sets.datas.sysFields.isDelete.length == 0 || this.sets.datas.sysFields.isDelete == "") {
      bodys['deleteFlag'] = [];
    } else {
      bodys['deleteFlag'] = [
        {
          "name": this.sets['datas']['sysFields']['isDelete'],
          "value": "0"
        }
      ]
    }
    if (this.sets.datas.nzNeedOrganize == true) {
      bodys['engineMap'] = {
        "organize": [
          {
            "name": "organizeField",
            "value": this.sets.datas.sysFields.createUser
          }
        ]
      }
    } else {
      bodys['engineMap'] = {}
    }
    console.log('searchMap', JSON.stringify(searchMap))
    console.log("bodys:" + JSON.stringify(bodys));
    // bodys:{"tableColumn":["test003_id","test003_name","test003_content"],"tableName":"t_test003","pageSize":8,"nowPage":0,"searchMap":{},"deleteFlag":[{"name":"flag","value":"0"}],"engineMap":{}}
    // bodys:{"tableColumn":["test003_id","test003_name","test003_content"],"tableName":"t_test003","pageSize":8,"nowPage":1,"tableSort":[],"searchMap":{},"deleteFlag":[{"name":"flag","value":"0"}],"engineMap":{}}
    this.http.postHttp("/system/tableData", bodys).subscribe(
      (data: any) => {
        this.loading = false;
        this.setService.setPublicStatus(status.blockid, status.eventName, status.statuName, 1);
        console.log("表格data:", this.sets.datas.jichengLeft, JSON.stringify(data));
        if (notClear === true && data.data['list'].length === 0) {
          if (this.sets.datas.jichengLeft) {
            this.otherSets.isFirst = true;
            for (let index = 0; index < this.dataSet.length; index++) {
              const form = this.forms['form' + this.dataSet[index].id] as FormGroup;;
              form.enable();

            }
          } else if (this.sets.datas.jichengRight) {
            if (this.bomData && this.bomData.length > 0) {
              this.setBomData();
            } else {
              this.otherSets.isFirst = true;
            }
          }
          return;
        }
        this.otherSets.isFirst = false;
        this.dataSet = [];
        this.dataSet = [...this.dataSet];
        this.forms = {};
        this.nzLoading = {};
        //翻译统计

        let transList = {};
        for (const key in this.sets.datas.ColumnData) {
          if (this.sets.datas.ColumnData[key]['translations'].length > 0) {
            transList[key] = this.sets.datas.ColumnData[key]['translations'];
          }
        }
        let upField = null;
        if (this.backnum.upField && this.backnum.used) {
          upField = this.backnum.upField
        }
        try {
          if (this.sets.datas.jichengLeft || this.sets.datas.jichengRight) {
            // 排序
            data.data['list'].sort((a, b) => a.POT_MATERIAL_PARENT.localeCompare(b.POT_MATERIAL_PARENT))
          }
        } catch (error) {
          console.error(error);
        }
        if (upField) this.sets.styles.nzNum = this.backnum.nzNum;

        data.data['list'].forEach(dataelement => {
          let length = 1;
          if (upField && dataelement[upField] && parseInt(dataelement[upField]) > 1) {
            length = parseInt(dataelement[upField]);
            this.sets.styles.nzNum = this.sets.styles.nzNum + length - 1;
          }
          console.log('length', length, this.sets.styles.nzNum)
          for (let index = 0; index < length; index++) {
            if (this.dataSet.length == 0) this.endId = 0;
            this.forms['form' + (++this.endId)] = this.getFormGroup();
            // this.dataSet.push(endId+1);
            for (const key in transList) {
              const trans = transList[key];
              trans.forEach(item => {
                if (dataelement[key] == item.value) {
                  dataelement[key] = item.transValue
                }
              });
            }

            this.dataSet.push({
              id: this.endId, edit: false, data: dataelement, first: false,
              checked: false,
              disabled: false
            })
            this.nzLoading[this.endId] = false;

          }

        })
        this.dataSet = [...this.dataSet]
        if (this.sets.styles.nzNum && (this.dataSet.length < this.sets.styles.nzNum || this.dataSet.length > this.sets.styles.nzNum)) this.form_addForm();

        this.nzTotal = data.data['total'];
        if (edit) {
          for (let index = 0; index < this.dataSet.length; index++) {
            const data = this.dataSet[index];
            console.log("默认编辑", edit, data, data.edit);

            this.form_edit_one(index, data)
          }
        }


      });
  }

  //
  allChecked = false;
  indeterminate = false;
  checkAll(value) {
    this.dataSet.forEach(data => {
      if (!data.disabled) {
        data.checked = value;
      }
    });
    this.refreshStatus();
  }
  refreshStatus() {
    const allChecked = this.dataSet.filter(value => !value.disabled).every(value => value.checked === true);
    const allUnChecked = this.dataSet.filter(value => !value.disabled).every(value => !value.checked);
    this.allChecked = allChecked;
    this.indeterminate = (!allChecked) && (!allUnChecked);
  }


  pzListening() {
    setTimeout(() => {
      this.setService.initEvent(this.blockid, 'pz');
      this.setService.pzEvents[this.blockid].subscribe(data => {
        switch (data['type']) {
          case 'simpleSearch':
            this.pzSearchData()
            break;
          case 'changeForm':
            if (this.dataSet.length > 0) {
              this.setService.onReLoadbBlock(this.layoutid);
            }
            break;
          case 'nzDynamicDatafalse':
            this.setService.sendChildEvent(this.blockid + 'select', data['type'], {}, 'pz')
            break;
          case 'nzPagingfalse':
            this.setService.sendChildEvent(this.blockid + 'select', data['type'], {}, 'pz')
            break;
          case 'refresh':
            this.setService.sendChildEvent(this.blockid + 'select', data['type'], {}, 'pz')
            break;
          default:
            break;
        }
      }
      )
    }, 100);

  }
  /** isNum 动态条数就绪 */
  backnum = { used: false, nzNum: 0, data: {}, isNum: false, upField: '', notShowEdit: false };
  Listening() {
    setTimeout(() => {
      this.setService.initEvent(this.blockid);
      this.setService.events[this.blockid].subscribe(
        async data => {
          console.log("Listening-formtable:", this.blockid, data['type'], JSON.stringify(data));
          switch (data['type']) {

            case 'search':

              this.searchMap = data['datas'];
              console.log("backnum", data['sets'])
              if (typeof data['sets'] != "undefined") {
                if (data['sets'] == "edit") {
                  this.searchData(this.searchMap, true, data['status'], true);

                } else if (data['sets'] == "edit,backnum") {
                  console.log("backnum-backnum", this.backnum, this.backnum.isNum)
                  if (this.backnum.isNum) {
                    console.log("backnum-backnum-dosearch", this.backnum)
                    this.searchData(this.searchMap, true, data['status'], true, true);
                    this.backnum.used = true;
                    this.backnum.data = data;
                  } else {
                    this.backnum.used = true;
                    this.backnum.data = data;
                  }
                } else if (data['sets'] == "edit2,backnum") {
                  // 可编辑 但不可见模式
                  console.log("backnum-backnum2", this.backnum)
                  if (this.backnum.isNum) {
                    this.searchData(this.searchMap, true, data['status'], true, true);
                    this.backnum.used = true;
                    this.backnum.data = data;
                    this.backnum.notShowEdit = true;
                  } else {
                    this.backnum.notShowEdit = true;
                    this.backnum.used = true;
                    this.backnum.data = data;
                  }
                }
              }
              else {
                this.searchData(this.searchMap, true, data['status']);
              }

              break;
            case 'editData':

              break;
            case 'mainFist':
              this.mainFist(data['datas'])
              break;
            case 'check_childTable':
              this.check_childTable(data['datas']);
              break;
            case 'check_childTableOne':
              // this.check_childTable(data['datas'], true);
              break;
            case 'updateNum':
              this.backnum.upField = data['datas'].upField;
              this.updateNum(data['datas'].value)
              break;

            case 'reset':
              console.log("form_addForm-reset:", this.blockid, data['type'], JSON.stringify(data));
              if ((this.backnum.isNum && this.sets.styles.nzDynamicNum) || !this.sets.styles.nzDynamicNum) {
                if (data.datas.param0 === "true") {
                  console.log("form_addForm-reset:1");
                  this.resetData();
                } else {
                  console.log("form_addForm-reset:2");

                  this.dataSet = [];
                  this.forms = {};
                  this.form_addForm();
                }

              } else {
                console.log("form_addForm-reset:0");

              }

              break;
            case 'focus':

              if ((data['datas']['index'] + 1) < this.dataSet.length) {
                const event = this.setService.events[this.blockid + 'form' + this.dataSet[data['datas']['index'] + 1]['id'] + data['datas']['columnName']]
                if (event) {
                  event.emit({
                    type: "focus",
                    datas: {}
                  });
                }

                console.log("mainfocus", this.blockid + 'form' + this.dataSet[data['datas']['index'] + 1]['id'] + data['datas']['columnName'])
              } else {

                for (const key in this.forms) {
                  const form = this.forms[key] as FormGroup;
                  for (const field in form.controls) {
                    // console.log('focus', field, this.sets.datas.ColumnData[field])
                    if (this.sets['datas']['ColumnData'][field]['canEdit']) {
                      if (!this.sets.datas.ColumnData[field]['nzBlockSets']['styles']['nzReadOnly']) {
                        // console.log('focus', this.blockid + 'form' + this.dataSet[1]['id'] + field)
                        this.setService.events[this.blockid + 'form' + this.dataSet[0]['id'] + field].emit({
                          type: "focus",
                          datas: {}
                        });
                        return;
                      }
                    }

                  }
                  break;
                }

              }
              break;
            case 'childChange':
              // 
              if (this.sets.datas.jichengLeft || this.sets.datas.jichengRight) {
                this.jichengCheck(data['datas'])
              }
              break;
            case 'DIDCheck':
              console.log('jichengCheck DIDCheck', data['datas'])

              const { value, formId, blockid } = data['datas'];

              for (const key in this.forms) {
                const form = this.forms[key] as FormGroup;
                if (form.controls['DID'] && form.controls['DID'].value === value) {
                  this.setService.events[blockid].emit({
                    type: "DIDRes",
                    datas: { formId: formId }
                  });
                  break
                }

              }
              break;
            case 'DIDRes':
              console.log('jichengCheck DIDRes', data['datas'])
              const form = this.forms[data['datas'].formId] as FormGroup;
              if (form.controls['DID'].valid) {
                form.controls['DID'].setErrors({
                  error: true, tableOnlyValue: true
                })
              } else {
                let count = 0;
                do {
                  count++;
                  await this.pageService.sleep(50);
                  if (form.controls['DID'].valid) {
                    form.controls['DID'].setErrors({
                      error: true, tableOnlyValue: true
                    })
                    count = 1001;
                  }
                  console.log('DIDRes', 'DID', form.controls['DID'].valid)

                } while (count < 200);
              }


              // setTimeout(() => {
              //   form.controls['DID'].setValue(form.controls['DID'].value + '重复')
              // }, 500);
              break
            case 'bomData':
              this.bomData = data['datas'].bomData;
              console.log('bomData', this.bomData, this.otherSets.isFirst)
              if (this.otherSets.isFirst) {
                this.setBomData();
              }

              break;
            case 'jichenUnlock':
              console.log('jichengCheck jichenUnlock', data['datas']);
              const lockData = data['datas'];
              const leftData = lockData.leftData as { DID: string, PARTNO: string, QTY: number };

              if (!leftData) return;
              this.jichengRightJson[leftData.PARTNO] = { edited: lockData.res, index: -1 };
              let isGet = false;
              for (let index = 0; index < this.dataSet.length; index++) {
                const { id, data } = this.dataSet[index];
                const form = this.forms['form' + id];
                if (data && data.PARTNO === leftData.PARTNO) {
                  // if(leftData.DID)
                  isGet = true;
                  if (lockData.res) {
                    form.enable();
                  } else {
                    if (form.enabled) {
                      form.disable();
                      for (const field in form.controls) {
                        if (Object.prototype.hasOwnProperty.call(form.controls, field)) {
                          const control = form.controls[field];
                          if (field !== 'QTY') {
                            control.setValue(data[field] || '');
                          }
                        }
                      }
                    }

                  }

                  break;
                }
              }

              break;
            default:
              break;
          }
        }
      )
    }, !this.static ? 100 : 0);

  }

  setBomData() {
    if (this.bomData && this.bomData.length > 0) {
      // 处理BomData
      const newData: { POT_MATERIAL_CODE: string, POT_MATERIAL_PARENT: string, [key: string]: any }[] = []
      const isNotDelete = {}
      const isAdd = {}
      for (const bomItem of this.bomData) {
        if (!isAdd[bomItem.POT_MATERIAL_PARENT]) {
          if (bomItem.POT_MATERIAL_PARENT === bomItem.POT_MATERIAL_CODE) {
            isNotDelete[bomItem.POT_MATERIAL_PARENT] = true;
            newData.push(bomItem);
            isAdd[bomItem.POT_MATERIAL_PARENT] = true;
          }
        }

      }
      this.bomData = newData;
      for (let index = 0; index < this.bomData.length; index++) {
        const bomItem = this.bomData[index];
        const formData = this.dataSet[index];
        if (formData) {
          const form = this.forms['form' + formData.id];
          formData.data['PARTNO'] = bomItem.POT_MATERIAL_CODE;
          form.controls['PARTNO'].setValue(bomItem.POT_MATERIAL_CODE);

          formData.data['POT_MATERIAL_PARENT'] = bomItem.POT_MATERIAL_PARENT;
          form.controls['POT_MATERIAL_PARENT'].setValue(bomItem.POT_MATERIAL_PARENT);
        }
      }


    }
  }

  jichengJson: { [key: string]: { DID: string, PARTNO: string, QTY: number } } = {

  }
  bomData: { POT_MATERIAL_CODE: string, POT_MATERIAL_PARENT: string, [key: string]: any }[] = [];
  jichengRightJson: { [PARTNO: string]: { edited: boolean, index?: number, id?: string } } = {

  }
  jichengCheck(data: { index: number, columnName: string, formId: string, value: string | number }) {
    if (!this.sets.datas.jichengRightId && !this.sets.datas.jichengLeftId) return;
    if (!data.value && data.value !== 0) return;
    const { index, columnName, formId, value } = data;
    console.log('jichengCheck', columnName, data, data.value, this.otherSets.isFirst);
    const form = this.forms[formId];
    if (!this.jichengJson[formId]) {
      this.jichengJson[formId] = {
        DID: null, PARTNO: null, QTY: null
      }
    }
    const item = this.jichengJson[formId];
    item[columnName] = value;
    if (columnName === 'DID') {
      item.PARTNO = null;
      item.QTY = null;
      // 校验
      console.log('jichengCheck DID', this.sets.datas.jichengRightId, this.sets.datas.jichengLeftId);

      if (this.sets.datas.jichengRightId) {
        this.setService.events[this.sets.datas.jichengRightId].emit({
          type: "DIDCheck",
          datas: { value: value, blockid: this.blockid, formId: formId }
        });
      } else {
        this.setService.events[this.sets.datas.jichengLeftId].emit({
          type: "DIDCheck",
          datas: { value: value, blockid: this.blockid, formId: formId }
        });
      }
    }
    console.log('jichengCheck', item, item.QTY, this.sets.datas.jichengRightId);
    if (this.otherSets.isFirst) return;
    if (!this.sets.datas.jichengRightId) return;
    console.log('jichengCheck1', item, item.QTY);

    if (item.DID && item.PARTNO && (item.QTY || item.QTY === 0)) {
      console.log('jichengCheck ok', item);
      // 调用接口。。。。
      const body = {
        "woCode": "MAJ50139175-001-079BE",
        "potBomCode": "BOM37174",
        "didList": [{
          "did": "08545950",
          "partno": "MAJ50139174-001%C",
          "qty": 1
        }]

      }
      this.sets.datas['nzServiceParam'].forEach(param => {
        const paramData = this.sets.datas.nzServiceParamDetail[param];
        if (paramData.urlName === 'woCode') {
          body.woCode = this.pageService.getServiceParam(paramData, this.activatedRoute);
        } else if (paramData.urlName === 'potBomCode') {
          body.potBomCode = this.pageService.getServiceParam(paramData, this.activatedRoute);
        }
      });
      body.didList[0].did = item.DID;
      body.didList[0].partno = item.PARTNO;
      body.didList[0].qty = item.QTY;
      console.log('jichengCheck body', body);
      // 测试开启
      // this.setService.events[this.sets.datas.jichengRightId].emit({
      //   type: "jichenUnlock",
      //   datas: { leftData: item, res: true }
      // });
      this.http.postHttp('/businessVerification/productBomVerification', body).subscribe(
        // this.http.postHttpAllUrl('http://localhost:8080/businessVerification/productBomVerification', body).subscribe(

        httpRes => {
          console.log('jichengCheck httpRes', httpRes);
          const res = httpRes.data.didList[0].edit || false;
          this.setService.events[this.sets.datas.jichengRightId].emit({
            type: "jichenUnlock",
            datas: { leftData: item, res: res }
          });
        }
      )


    }
  }

  resetData() {
    for (const key in this.forms) {
      const form = this.forms[key] as FormGroup;
      for (const field in form.controls) {
        console.log('ColumnData', field, this.sets.datas.ColumnData[field])
        if (this.sets['datas']['ColumnData'][field]['canEdit']) {
          if (!this.sets.datas.ColumnData[field]['nzBlockSets']['styles']['nzReadOnly']) {
            form.controls[field].setValue('');

          }
        }

      }
    }
  }
  /**
   * 
   * @param data 
   * @param one 为true时，是本表单独校验
   */
  check_childTable(data, one = false, id?: string) {
    let getKeyPart = false;
    let KeyPartData = [];
    let KeyPartKey = '';
    try {
      this.sets.datas.nzHiddendatas.nzNames.forEach(paramName => {
        if ('keyPart' === this.sets.datas.nzHiddendatas.nzSets[paramName].name) {
          delete this.pageService.pageBlockDatas[this.blockid]['nzHiddendatas'][paramName];
          getKeyPart = true;
          KeyPartKey = paramName;
        }
      });
    } catch (error) {

    }

    this.statusOfSubmitAll = 0;
    let ok = true
    let formsNum = 0;
    let firsecontrol;
    let onlyValue: {
      [key: string]: {
        formId: string,
        field: string,
        enabled: boolean
      }
    } = {}
    for (const key in this.forms) {
      formsNum++;
      const form = this.forms[key];
      if (!one) {
        // console.log('form-valid', form, form.valid, form.invalid)
        if (form.enabled && !form.valid) {
          ok = false;
        }
        // if (this.sets.datas.jichengRight || this.sets.datas.jichengLeft ) {
        //   if (!form.valid) {
        //     ok = false;
        //     if (!form.enabled) {
        //       form.enable();
        //     }
        //   }
        // } else {

        // }

      } else {
        if (id) {
          if (key !== 'from' + id) continue;
        }
      }

      console.log("onlyValue-form", formsNum, key, form.controls)
      let i = 1;
      const item = {}
      for (const field in form.controls) {
        console.log("onlyValue-index", i++, field,)
        item[field] = form.controls[field].value;
        if (form.controls.hasOwnProperty(field)) {

          const control = form.controls[field];
          // console.log('control.validator', field, this.sets.datas.ColumnData[field]['nzFormGroupData'])
          const neCheck: string[] = this.sets.datas.ColumnData[field]['nzFormGroupData'].nzCheck
          if (neCheck.includes('required') && !control.value) {
            ok = false;
            if (form.enabled) {
              control.setErrors({
                error: true, required: true
              })
            } else {
              form.enable();
              control.setErrors({
                error: true, required: true
              })
            }

          }
          item[field] = control.value;
          if (this.sets.datas.ColumnData[field]['onlyValue']) {
            if ((control.value != undefined && control.value == "") || (this.sets.datas.jichengRight && !control.value)) {

            }
            else if (typeof onlyValue[field + '_' + control.value] == "undefined") {
              if (control.value != "") {
                console.log("onlyValue====change", key, control.value)
                onlyValue[field + '_' + control.value] = {
                  formId: key,
                  field: field,
                  enabled: form.enabled
                };
                firsecontrol = control;
              }

            }
            else {
              console.log("onlyValue1", 'field', field, onlyValue[field + '_' + control.value])
              ok = false;
              console.log("onlyValue", key, 'firsecontrol', control)
              const lastData = onlyValue[field + '_' + control.value]
              const lastForm = this.forms[lastData.formId]
              if (form.enabled) {
                control.setErrors({
                  error: true, tableOnlyValue: true
                })

              } else if (lastForm.enabled) {
                lastForm.controls[lastData.field].setErrors({
                  error: true, tableOnlyValue: true
                })
              } else {

                form.enable();
                control.setErrors({
                  error: true, tableOnlyValue: true
                })
              }



              break;
            }
            console.log("onlyValue2", onlyValue[field + '_' + control.value], control)

          }

        }
        if (!ok && !getKeyPart) break;
      }
      KeyPartData.push(item);
      if (!ok && !getKeyPart) break;
    }
    console.log('blockValue33', KeyPartData, ok);

    if (!one) {
      if (!ok || formsNum < data.num) {
        this.pageService.pageBlockDatas[this.blockid]['nzHiddendatas'][KeyPartKey] = {
          name: 'for KeyPart',
          value: KeyPartData,
          state: 'fail',
          msg: ok + "," + formsNum + "," + data.num
        }
        this.setService.sendEvent(data.blockid, 'check_childTable_ans', false)
      } else {
        if (getKeyPart) {
          this.pageService.pageBlockDatas[this.blockid]['nzHiddendatas'][KeyPartKey] = {
            name: 'for KeyPart',
            value: KeyPartData,
            state: 'success',
            msg: ""
          }
        }

        this.setService.sendEvent(data.blockid, 'check_childTable_ans', true)

      }
    } else {
      return ok;
    }

  }
  mainFist(datas) {
    const idValue = datas.key;
    const field = datas.field;
    const bodyData = datas.bodyData;

    //body处理
    let bodyJson = {};
    bodyData.forEach(element => {
      bodyJson[element.name] = {
        name: '',
        value: element.value,
        type: element.type,
        rule: element.rule
      }
    });
    console.log("mainFist", idValue, field, bodyData);
    let data = []
    field.forEach(element => {
      if (element.valuefield == '@cb_primary_key') {
        data.push({
          name: element.field,
          value: idValue,
          type: 'string',
          rule: ''
        })
      } else {
        bodyJson[element.valuefield]['name'] = element.field;
        data.push(bodyJson[element.valuefield])
      }
    });
    console.log("mainFist,data", data);
    this.form_submit_all(data, true)


  }
  keydown(event) {
    console.log('keydown-input')
    if (this.sets.datas.nzEnterFilter && event.keyCode == 13) return false;
    console.log("do");
  }
  updateNum(value) {
    let sql = this.sets.styles.nzNumSql;

    if (typeof value != "undefined" && value != "") sql = sql.replace(new RegExp("@linkage1", "gm"), value);

    let body = {
      // "dynamicSql": 'select test001_name as value from t_test001 where test001_id=16',
      "dynamicSql": this.pageService.replaceParam(this.jwtService.replaceUser(sql), this.blockid),
      "pageSize": 0,
      "nowPage": 0,
      "paramMap": [],
      "tableSort": [],
      "searchMap": {
      }
    }
    console.log("updateNum-body:" + JSON.stringify(body));
    if (sql.indexOf("@linkage") == -1 && body.dynamicSql != "") {
      this.http.postHttp("/system/dynamicSql", body).subscribe(
        (data: any) => {
          console.log("updateNum-data:" + JSON.stringify(data));
          if (data.data.list.length > 0) {
            this.sets.styles.nzNum = parseInt(data.data.list[0]['VALUE']);
            this.backnum.nzNum = this.sets.styles.nzNum;

            this.sets.styles.nzPageSize = parseInt(data.data.list[0]['VALUE']);
            if (this.dataSet.length < this.sets.styles.nzNum || this.dataSet.length > this.sets.styles.nzNum) this.form_addForm();
            if (this.backnum.used) {
              console.log("updateNum-dynamicSql:DOSEARCH");
              this.searchMap = this.backnum.data['datas'];
              this.searchData(this.searchMap, true, this.backnum.data['status'], true, true);

            }
            this.backnum.isNum = true;
          }
          else {

          }
        })
    }
  }


}

